import Vue from 'vue'
import Hotjar from 'vue-hotjar'

Vue.use(Hotjar, {
    id: '1168699', // Hotjar Site ID
    isProduction: true, //utils.hostnamesIsProd()
})
